// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3JppH","title":"AfterFrontImage_title__1WsRJ"};